/*!
 * AUIGrid 3.0.12 License
 * Product ID : AUIGrid-EN-71466-493632-221228
 * Authorized Domain(or IP) : ims.idaehan.com
 * www.auisoft.net
 */
/* eslint-disable */
AUIGridLicense =
  "eyJjdCI6IndFTFJ0VjBIZmVISzB2VU5sM2FVNWhDcjU4RDVzUE40RFZSdU9lZVpld0puXC9FSlBDQnFvb0RLNzRpcGVFeitoaFBwSGVCd05MWGtSTkNXd0hVdkw5dXNZamo4eUdOMUJtNUNRNVBmWEpNdG5XOG1PTnptRVpOTXNNSVJNbzJZTk1WNytJMThSUWlDWDJyUkJZMGJmckE9PSIsIml2IjoiYjQ2MzcyYzk1MDhlNjUwMTg3YjQ3OWZlZTUwZWFiZDAiLCJzIjoiOGQ1ODhhOGZlOWVhMGU5ZCJ9";
